import { FundRangeFundSurveyEditorViewModel } from "src/app/surveys/fundrange-survey/fundrange-fund-survey/viewmodels/fund.range.fund.survey.editor.viewmodel";

export class SaveFundRangeFundSurveyCommand {
  constructor(public survey: FundRangeFundSurveyEditorViewModel) { }
}
